var _defineProperty = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _objectSpread = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _slicedToArray = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var $hnlpS$react = require("react");
var $hnlpS$radixuireactcontext = require("@radix-ui/react-context");
var $hnlpS$radixuireactcomposerefs = require("@radix-ui/react-compose-refs");
var $hnlpS$radixuireactslot = require("@radix-ui/react-slot");
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
$parcel$export(module.exports, "createCollection", function () {
  return $1a96635ec239608b$export$c74125a8e3af6bb2;
});

// We have resorted to returning slots directly rather than exposing primitives that can then
// be slotted like `<CollectionItem as={Slot}>…</CollectionItem>`.
// This is because we encountered issues with generic types that cannot be statically analysed
// due to creating them dynamically via createCollection.
function $1a96635ec239608b$export$c74125a8e3af6bb2(name) {
  /* -----------------------------------------------------------------------------------------------
  * CollectionProvider
  * ---------------------------------------------------------------------------------------------*/
  var PROVIDER_NAME = name + 'CollectionProvider';
  var _$hnlpS$radixuireactc = $hnlpS$radixuireactcontext.createContextScope(PROVIDER_NAME),
    _$hnlpS$radixuireactc2 = _slicedToArray(_$hnlpS$radixuireactc, 2),
    createCollectionContext = _$hnlpS$radixuireactc2[0],
    createCollectionScope = _$hnlpS$radixuireactc2[1];
  var _createCollectionCont = createCollectionContext(PROVIDER_NAME, {
      collectionRef: {
        current: null
      },
      itemMap: new Map()
    }),
    _createCollectionCont2 = _slicedToArray(_createCollectionCont, 2),
    CollectionProviderImpl = _createCollectionCont2[0],
    useCollectionContext = _createCollectionCont2[1];
  var CollectionProvider = function CollectionProvider(props) {
    var scope = props.scope,
      children = props.children;
    var ref = $parcel$interopDefault($hnlpS$react).useRef(null);
    var itemMap = $parcel$interopDefault($hnlpS$react).useRef(new Map()).current;
    return /*#__PURE__*/$parcel$interopDefault($hnlpS$react).createElement(CollectionProviderImpl, {
      scope: scope,
      itemMap: itemMap,
      collectionRef: ref
    }, children);
  };
  /*#__PURE__*/
  Object.assign(CollectionProvider, {
    displayName: PROVIDER_NAME
  });
  /* -----------------------------------------------------------------------------------------------
  * CollectionSlot
  * ---------------------------------------------------------------------------------------------*/
  var COLLECTION_SLOT_NAME = name + 'CollectionSlot';
  var CollectionSlot = /*#__PURE__*/$parcel$interopDefault($hnlpS$react).forwardRef(function (props, forwardedRef) {
    var scope = props.scope,
      children = props.children;
    var context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
    var composedRefs = $hnlpS$radixuireactcomposerefs.useComposedRefs(forwardedRef, context.collectionRef);
    return /*#__PURE__*/$parcel$interopDefault($hnlpS$react).createElement($hnlpS$radixuireactslot.Slot, {
      ref: composedRefs
    }, children);
  });
  /*#__PURE__*/
  Object.assign(CollectionSlot, {
    displayName: COLLECTION_SLOT_NAME
  });
  /* -----------------------------------------------------------------------------------------------
  * CollectionItem
  * ---------------------------------------------------------------------------------------------*/
  var ITEM_SLOT_NAME = name + 'CollectionItemSlot';
  var ITEM_DATA_ATTR = 'data-radix-collection-item';
  var CollectionItemSlot = /*#__PURE__*/$parcel$interopDefault($hnlpS$react).forwardRef(function (props, forwardedRef) {
    var scope = props.scope,
      children = props.children,
      itemData = _objectWithoutProperties(props, ["scope", "children"]);
    var ref = $parcel$interopDefault($hnlpS$react).useRef(null);
    var composedRefs = $hnlpS$radixuireactcomposerefs.useComposedRefs(forwardedRef, ref);
    var context = useCollectionContext(ITEM_SLOT_NAME, scope);
    $parcel$interopDefault($hnlpS$react).useEffect(function () {
      context.itemMap.set(ref, _objectSpread({
        ref: ref
      }, itemData));
      return function () {
        return void context.itemMap.delete(ref);
      };
    });
    return /*#__PURE__*/$parcel$interopDefault($hnlpS$react).createElement($hnlpS$radixuireactslot.Slot, _defineProperty(_defineProperty({}, ITEM_DATA_ATTR, ''), "ref", composedRefs), children);
  });
  /*#__PURE__*/
  Object.assign(CollectionItemSlot, {
    displayName: ITEM_SLOT_NAME
  });
  /* -----------------------------------------------------------------------------------------------
  * useCollection
  * ---------------------------------------------------------------------------------------------*/
  function useCollection(scope) {
    var context = useCollectionContext(name + 'CollectionConsumer', scope);
    var getItems = $parcel$interopDefault($hnlpS$react).useCallback(function () {
      var collectionNode = context.collectionRef.current;
      if (!collectionNode) return [];
      var orderedNodes = Array.from(collectionNode.querySelectorAll("[".concat(ITEM_DATA_ATTR, "]")));
      var items = Array.from(context.itemMap.values());
      var orderedItems = items.sort(function (a, b) {
        return orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current);
      });
      return orderedItems;
    }, [context.collectionRef, context.itemMap]);
    return getItems;
  }
  return [{
    Provider: CollectionProvider,
    Slot: CollectionSlot,
    ItemSlot: CollectionItemSlot
  }, useCollection, createCollectionScope];
}